import { Directive, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { SetTitle } from 'rt-titles';
import { filter, take } from 'rxjs/operators';
import {
  AfterClose,
  CloseTab,
  OnClose,
  OnConfirmBeforeClose,
  OnSave,
  TabModel,
  TabsEventManagerService,
  UpdateTabLabel
} from 'shared';
import { UUID } from 'symbols';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
  ConfirmLevel
} from '../../../../apps/frontend/src/app/confirm-dialog/confirm-dialog.component';

@Directive({
  selector: '[tabLifecycle]',
  standalone: true
})
export class TabLifecyclesDirective implements OnClose, OnConfirmBeforeClose, OnSave, AfterClose, OnInit {
  readonly listenerUUID: string = this.route.snapshot.data['tabUUID'];
  isValidForm: boolean = false;

  constructor(
    private tabsEventManager: TabsEventManagerService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected store: Store,
    protected dialog: MatDialog
  ) {
  }


  onConfirmBeforeClose(tab: TabModel) {
    if (this.listenerUUID !== tab.tabUUID) {
      return;
    }
    this.store.dispatch(new Navigate([tab.url]));
    if (tab.isValidData) {
      if (tab.versionDifferent) {
        if (tab.canSaveForce) {
          this.openConfirmForceSave(tab);
        } else {
          this.openConfirmCloseWithoutSave(tab.id);
        }
      } else {
        this.openConfirmSaveDocAfterClose(tab);
      }
    } else {
      this.openConfirmCloseWithoutSave(tab.id);
    }
  }


  ngOnInit(tabUUID?: string): void {
    this.tabsEventManager.registration(this, tabUUID);
  }

  openConfirmSaveDocAfterClose(tab: TabModel) {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      data: {
        caption: 'Документ було змінено',
        detailsText: 'Бажаєте зберегти зміни?',
        enableReject: true,
        confirm: 'Так',
        reject: 'Ні',
        cancel: 'Відміна'
      },
      panelClass: 'confirm-dialog'
    });
    dialogRef
      .afterClosed()
      .pipe(
        take(1)
      )
      .subscribe((res) => {
        if (res === true) {
          this.tabsEventManager.onSave(tab);
        } else if (res === false) {
          this.store.dispatch(
            new UpdateTabLabel({
              url: this.router.url,
              isChanged: false
            })
          );

          this.store.dispatch(
            new CloseTab({
              url: this.router.url,
              id: tab.id
            })
          );

          this.tabsEventManager.afterClose(tab.id);
        }
      });
  }

  openConfirmCloseWithoutSave(candidateId: string) {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      data: {
        caption: 'Хочете закрити без збереження змін?',
        detailsText: 'Форма не валідна, зберегти неможливо! <br/>Закрити без збереження?',
        parseHTML: true,
        confirm: 'Так',
        reject: 'Ні',
        cancel: 'Відміна',
        level: ConfirmLevel.WARNING
      },
      panelClass: 'confirm-dialog'
    });
    dialogRef
      .afterClosed()
      .pipe(
        take(1),
        filter(res => res === true)
      )
      .subscribe(() => {
        this.store.dispatch(
          new UpdateTabLabel({
            url: this.router.url,
            isChanged: false
          })
        );
        this.store.dispatch(new CloseTab({
          url: this.router.url,
          id: candidateId
        }));

        this.tabsEventManager.afterClose(candidateId);
      });
  }

  closeTab(isChanged: boolean) {
    this.store.dispatch(new CloseTab({
      url: this.router.url,
      isChanged
    }));
  }

  onClose(tab: TabModel) {
  }

  onSave(tab: TabModel) {
  }

  afterClose(docId: UUID) {
  }

  updateTabLabel(tab: TabModel) {
    this.store.dispatch(new UpdateTabLabel(tab));
    this.store.dispatch(new SetTitle(tab.label));
  }


  isValidData(valid: boolean): void {
    this.isValidForm = valid;
    this.store.dispatch(new UpdateTabLabel({
      url: this.router.url,
      isValidData: valid
    }));
  }

  openConfirmForceSave(tab: TabModel) {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      data: {
        caption: 'Хочете зберегти примусово?',
        detailsText: 'Версія документу не співпадає, якщо продовжити, то документ буде перезаписано!',
        level: ConfirmLevel.ERROR,
        enableReject: true,
        confirm: 'Так',
        reject: 'Ні',
        cancel: 'Відміна'
      },
      panelClass: 'confirm-dialog'
    });
    dialogRef
      .afterClosed()
      .pipe(
        take(1)
      )
      .subscribe((res) => {
        if (res === true) {
          this.tabsEventManager.onSave(tab, true);
        } else if (res === false) {
          this.store.dispatch(new UpdateTabLabel({
            url: this.router.url,
            isChanged: false
          }));
          this.store.dispatch(new CloseTab({
            url: this.router.url,
            id: tab.id
          }));
        }
      });
  }
}
